<ng-container *appShowForRsaUser>
  <app-departments-dropdown [departmentName]="installationDetailsStore.departmentName$ | async">
  </app-departments-dropdown>
</ng-container>

<app-feature-details-grid>
  <!-- view for maintainers -->
  <ng-container *appHideForRsaUser>
    <ng-container *ngTemplateOutlet="maintainerView"></ng-container>
  </ng-container>

  <!-- view for RSA users -->
  <ng-container *appShowForRsaUser>
    <ng-container *ngTemplateOutlet="rsaView"></ng-container>
  </ng-container>
</app-feature-details-grid>
<app-invitation-list
  data-at-invitation-list
  *appShowForRsaUser
  [installationId]="installationId"
></app-invitation-list>
<app-access-list *appShowForRsaUser [installationId]="installationId"></app-access-list>

<ng-template #maintainerView>
  <app-feature-list-container>
    <!-- gatewayProperties.serial -->
    <app-feature-list-item
      data-at-gateway-serial
      label="{{ '+INSTALLATIONS.INSTALLATION.COMMUNICATION_MODULE.TITLE' | translate }}:"
      value="{{ gateway?.serial | dash }}"
      [attr.data-feature]="'gateway.serial'"
    >
    </app-feature-list-item>
    <!-- gatewayProperties.gatewayType -->
    <app-feature-list-item
      data-at-gateway-type
      label="{{ '+INSTALLATIONS.INSTALLATION.GATEWAY_TYPE.TITLE' | translate }}:"
      value="{{ (gatewayType$ | async) || translateService.instant('+GENERAL.GATEWAY') }}"
      [attr.data-feature]="'gateway.gatewayType'"
    ></app-feature-list-item>
    <!-- gatewayProperties.firmware -->
    <app-feature-list-item
      *ngIf="gatewayFirmwareVersion$ | async | ready as feature"
      class="gateway-firmware"
      data-at-firmware
      label="{{ '+INSTALLATIONS.INSTALLATION.FIRMWARE_VERSION.TITLE' | translate }}:"
      [isNgContent]="true"
      [attr.data-feature]="feature.feature"
    >
      <span>{{ feature | featureValue: 'version' | dash }}</span>
    </app-feature-list-item>

    <div class="wrapper" *ngIf="isFirmwareOutdated$ | async">
      <app-banner
        class="wrapper__banner"
        feature
        type="warning"
        isFullWidth="true"
        [title]="'+GENERAL.ACTION_REQUIRED' | translate"
      >
        {{ '+INSTALLATIONS.INSTALLATION.GATEWAY_UPDATE_AVAILABLE' | translate }}
        <gateway-firmware-update-button
          [gatewaySerial]="gateway?.serial"
          [installationId]="installationId"
        ></gateway-firmware-update-button>
      </app-banner>
    </div>

    <!-- gatewayProperties.lastStatusChangedAt -->
    <app-feature-list-item
      data-at-last-status-changed
      [value]="gateway?.lastStatusChangedAt | date: 'short' | dash"
      label="{{
        '+INSTALLATIONS.INSTALLATION.GATEWAY_PROPERTIES.LAST_STATUS_CHANGED.TITLE' | translate
      }}:"
      [attr.data-feature]="'lastStatusChangedAt'"
    >
    </app-feature-list-item>
    <!-- acceptedInvitationDate -->
    <app-feature-list-item
      data-at-accepted-invitation-date
      [value]="acceptedDateInvitation$ | async | date: 'shortDate' | dash"
      label="{{ '+INSTALLATIONS.INSTALLATION.BOILER_PROPERTIES.ACCEPTED_AT.TITLE' | translate }}:"
      [attr.data-feature]="'acceptedDateInvitation'"
    >
    </app-feature-list-item>
  </app-feature-list-container>
  <app-feature-list-container>
    <!-- gateway.status -->
    <app-feature-list-item
      *ngIf="status$ | async | ready as feature"
      data-at-gateway-status
      data-at-value
      label="{{ '+INSTALLATIONS.INSTALLATION.GATEWAY_PROPERTIES.STATUS.TITLE' | translate }}:"
      value="{{ feature.properties?.online?.value | translateStatus | dash }}"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>

    <ng-container *ngrxLet="wifi$ as wifiFeature">
      <!-- gateway.wifi -->
      <app-feature-list-item
        data-at-wifi-strength
        *ngIf="wifiFeature | ready as feature"
        label="{{ '+INSTALLATIONS.INSTALLATION.WIFI_STRENGTH.TITLE' | translate }}:"
        value="{{ feature.properties?.strength?.value | translateWifiStrength }} {{
          feature.properties?.strength?.value | suffix: SUFFIX.decibelMilliWatt
        }}"
        [attr.data-feature]="feature.feature"
      >
      </app-feature-list-item>

      <!-- no wifi -->
      <app-feature-list-item
        *ngIf="!(wifiFeature | ready)"
        label="{{ '+INSTALLATIONS.INSTALLATION.WIFI_STRENGTH.TITLE' | translate }}:"
        value="{{ '' | dash }}"
        [attr.data-feature]="'gateway.wifi'"
      >
      </app-feature-list-item>
    </ng-container>
  </app-feature-list-container>
</ng-template>

<ng-template #rsaView>
  <app-feature-list-container>
    <!-- gatewayProperties.serial -->
    <app-feature-list-item
      data-at-gateway-serial
      label="{{ '+INSTALLATIONS.INSTALLATION.COMMUNICATION_MODULE.TITLE' | translate }}:"
      value="{{ gateway?.serial | dash }}"
      [attr.data-feature]="'gateway.serial'"
    >
    </app-feature-list-item>
    <!-- gatewayProperties.gatewayType -->
    <app-feature-list-item
      data-at-gateway-type
      label="{{ '+INSTALLATIONS.INSTALLATION.GATEWAY_TYPE.TITLE' | translate }}:"
      value="{{ (gatewayType$ | async) || translateService.instant('+GENERAL.GATEWAY') }}"
      [attr.data-feature]="'gateway.gatewayType'"
    ></app-feature-list-item>
    <!-- gatewayProperties.firmware -->
    <app-feature-list-item
      *ngIf="gatewayFirmwareVersion$ | async | ready as feature"
      class="gateway-firmware"
      data-at-firmware
      label="{{ '+INSTALLATIONS.INSTALLATION.FIRMWARE_VERSION.TITLE' | translate }}:"
      [isNgContent]="true"
      [attr.data-feature]="feature.feature"
    >
      <span>{{ feature | featureValue: 'version' | dash }}</span>
    </app-feature-list-item>

    <div class="wrapper" *ngIf="isFirmwareOutdated$ | async">
      <app-banner
        class="wrapper__banner"
        feature
        type="warning"
        isFullWidth="true"
        [title]="'+GENERAL.ACTION_REQUIRED' | translate"
      >
        {{ '+INSTALLATIONS.INSTALLATION.GATEWAY_UPDATE_AVAILABLE' | translate }}
        <gateway-firmware-update-button
          [gatewaySerial]="gateway?.serial"
          [installationId]="installationId"
        ></gateway-firmware-update-button>
      </app-banner>
    </div>

    <!-- gateway.status -->
    <app-feature-list-item
      *ngIf="status$ | async | ready as feature"
      data-at-gateway-status
      label="{{ '+INSTALLATIONS.INSTALLATION.GATEWAY_PROPERTIES.STATUS.TITLE' | translate }}:"
      value="{{ feature.properties?.online?.value | translateStatus | dash }}"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>

    <ng-container *ngrxLet="wifi$ as wifiFeature">
      <!-- gateway.wifi -->
      <app-feature-list-item
        data-at-wifi-strength
        *ngIf="(gatewayStore.isWifiEnabled$ | async) && wifiFeature | ready as feature"
        label="{{ '+INSTALLATIONS.INSTALLATION.WIFI_STRENGTH.TITLE' | translate }}:"
        value="{{ feature.properties?.strength?.value | translateWifiStrength }} {{
          feature | value2: 'strength' | suffix: SUFFIX.decibelMilliWatt
        }}"
        [attr.data-feature]="feature.feature"
      >
      </app-feature-list-item>

      <!-- no wifi -->
      <app-feature-list-item
        *ngIf="!(wifiFeature | ready) && (gatewayStore.isWifiEnabled$ | async)"
        label="{{ '+INSTALLATIONS.INSTALLATION.WIFI_STRENGTH.TITLE' | translate }}:"
        value="{{ '' | dash }}"
        [attr.data-feature]="'gateway.wifi'"
      >
      </app-feature-list-item>
    </ng-container>
  </app-feature-list-container>

  <app-feature-list-container>
    <!-- gatewayProperties.lastStatusChangedAt -->
    <app-feature-list-item
      data-at-last-status-changed
      [value]="gateway?.lastStatusChangedAt | date: 'short' | dash"
      label="{{
        '+INSTALLATIONS.INSTALLATION.GATEWAY_PROPERTIES.LAST_STATUS_CHANGED.TITLE' | translate
      }}:"
      [attr.data-feature]="'lastStatusChangedAt'"
    >
    </app-feature-list-item>
    <!-- gatewayProperties.producedAt -->
    <app-feature-list-item
      data-at-produced-date
      [value]="gateway?.producedAt | date: 'shortDate' | dash"
      label="{{ '+INSTALLATIONS.INSTALLATION.GATEWAY_PROPERTIES.PRODUCED_AT.TITLE' | translate }}:"
      [attr.data-feature]="'producedAt'"
    >
    </app-feature-list-item>
    <!-- gatewayProperties.createdAt -->
    <app-feature-list-item
      data-at-created-date
      [value]="gateway?.createdAt | date: 'shortDate' | dash"
      label="{{ '+INSTALLATIONS.INSTALLATION.GATEWAY_PROPERTIES.CREATED_AT.TITLE' | translate }}:"
      [attr.data-feature]="'createdAt'"
    >
    </app-feature-list-item>

    <!-- gatewayProperties.registeredAt -->
    <app-feature-list-item
      data-at-registered-date
      [value]="gateway?.registeredAt | date: 'shortDate' | dash"
      label="{{ '+INSTALLATIONS.INSTALLATION.GATEWAY_PROPERTIES.REGISTERED.TITLE' | translate }}:"
      [attr.data-feature]="'registeredAt'"
    >
    </app-feature-list-item>
  </app-feature-list-container>
</ng-template>
